import { chatFileFolderPathError } from "@hightouch/lib/llm/chat-file-folder-path";

/** The folder a file came from relative to what was dropped (`Brand A/Final`), or undefined for a loose or pasted file. */
export const folderPathOf = (file: File): string | undefined => {
  const path = relativePathOf(file);
  if (!path) return undefined;
  const segments = path.split("/").filter(isMeaningfulSegment);
  // The last segment is the file itself.
  segments.pop();
  const folderPath = segments.join("/");
  // The API refuses what it can't store safely, such as a ".." folder, and a file sent without a folder still attaches.
  return folderPath && chatFileFolderPathError(folderPath) === null
    ? folderPath
    : undefined;
};

const relativePathOf = (file: File): string | undefined => {
  // file-selector sets this to a dropped entry's fullPath, and a loose file's is its bare name.
  const path: unknown = (file as { path?: unknown }).path;
  if (typeof path === "string" && path.length > 0) return path;
  return file.webkitRelativePath || undefined;
};

const isMeaningfulSegment = (segment: string) =>
  segment !== "" && segment !== ".";
